import {Component} from '@angular/core';
import {Compbaser} from "../../../components/compbaser/compbases";
import {TranslocoService} from "@ngneat/transloco";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {animate, style, transition, trigger} from "@angular/animations";
import {StoreSelectorsService} from "../../../services";
import {ToastrService} from "ngx-toastr";
import {LocalStoreService} from "../../../services/local-store.service";
import {UserService} from "../../../services/user.service";
import {faCcPaypal} from "@fortawesome/free-brands-svg-icons";

@Component({
    selector: 'app-order-completed',
    styleUrls: [`./order-completed.component.scss`],
    templateUrl: './order-completed.component.html',
    animations: [
        trigger(
            'inOutAnimation',
            [
                transition(
                    ':enter',
                    [
                        style({height: 0, opacity: 0}),
                        animate('1s ease-out',
                            style({height: 150, opacity: 1}))
                    ]
                ),
                transition(
                    ':leave',
                    [
                        style({height: 150, opacity: 1}),
                        animate('1s ease-in',
                            style({height: 0, opacity: 0}))
                    ]
                )
            ]
        )
    ]
})
export class OrderCompletedComponent extends Compbaser {
    navigationEnd: NavigationEnd;
    orderNumber;
    faCcPaypal = faCcPaypal;

    constructor(private translocoService: TranslocoService, private localStoreService: LocalStoreService, private userService: UserService,
                private router: Router, private route: ActivatedRoute, private storeSelector: StoreSelectorsService, private toastr: ToastrService) {
        super();
        this.cod(
            this.route.paramMap.subscribe((routeParams) => {
                this.orderNumber = routeParams.get('order_id');
                this.localStoreService.removeCartStorage();
                setTimeout(() => {
                    this.router.navigate([`/orders/${this.orderNumber}`], {relativeTo: this.route});
                }, 3000);
            })
        );
        this.cod(
            this.router.events.subscribe((e) => {
                if (e instanceof NavigationEnd) {
                    this.navigationEnd = e;
                }
            })
        );
    }

    onGoOrders() {
        this.router.navigate([`/orders/${this.orderNumber}`], {relativeTo: this.route});
    }
}
